import { match } from 'ts-pattern'
import {
  RevenueRecognitionMethod,
  LedgerAccountName
} from 'common/types/revenueRecognition.types'

export const toRevenueRecognitionMethodLabel = (
  revenueRecognitionMethod: RevenueRecognitionMethod
) => {
  return match(revenueRecognitionMethod)
    .with('MILESTONE', () => 'Milestone')
    .with('STRAIGHT_LINE', () => 'Straight line')
    .with('USAGE', () => 'Usage')
    .with('POINT_IN_TIME', () => 'Point in time')
    .exhaustive()
}

export const toLedgerAccountNameLabel = (
  ledgerAccountName: LedgerAccountName
) => {
  return match(ledgerAccountName)
    .with('RECOGNIZED_REVENUE', () => 'Recognized revenue')
    .with('UNBILLED_REVENUE', () => 'Unbilled revenue')
    .with('BILLED_REVENUE', () => 'Billed revenue')
    .with('DEFERRED_REVENUE', () => 'Deferred revenue')
    .exhaustive()
}
